import { PAYMENT_SCREENS } from "constants/paymentScreens";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { AppCallback, doCallAppCallback } from "helpers/utils/webView";
import { getStringFromId } from "helpers/vernacular";
import { PAYMENT_FLOWS } from "constants/payment";
import { trackBackButtonClickToSavedPaymentPage } from "layouts/Payment/common/dependencies/tracking";
import { setCookie } from "../../../helpers/utils/cookie";
import { toLowerCase } from "../../../logics/src/utils/toLowerCase";
import { logger } from "logging";
import { razorPayIntegrationInstance } from "services/RazorPayIntegration/razorpayIntegration";
import { PAYMENT_MODES } from "../../../constants/paymentModes";
import { getMobileOperatingSystem, getRemoteConfig, getBrowserName } from "../../../helpers";
import { ACCORDIAN } from "constants/index";
import { formatNumber } from "helpers/utils/numberFormatter";


interface ILoadUpiIntentForWeb{
  razorPayKey: string;
  cashFreePaymentGateway: string;
  setIsGPayIntentAvailable: React.Dispatch<React.SetStateAction<boolean>>;
  setIsGpayIntentLoading: React.Dispatch<React.SetStateAction<boolean>>;
  gPayExperiment: boolean;
  setIsUpiIntentAppsInfoLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}
interface IUpiIntentVisibleOnWeb{
  availablePaymentMethods: [string];
  isExperimentEnable?: boolean;
  cashFreePaymentGateway?: string;
  isApp?: boolean;
  gPayExperiment?: boolean;
  setIsGpayIntentLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const getHeaderTitle = (flow: string, grandTotal: string, paymentScreen: string, isNewPaymentMethodVisibleOnScreen1: boolean) => {
    const allPaymentTitle = getStringFromId(VERNACULAR_STRING_IDS.DYNAMIC_PAY, `Pay ${`₹${formatNumber(grandTotal)}` || ""}`, { count: grandTotal });

    let headerTitle = getStringFromId(
        VERNACULAR_STRING_IDS.SELECT_ADDRESS_AND_PAY,
        VERNACULAR_DEFAULT_MESSAGES.SELECT_ADDRESS_AND_PAY
    );

    let dataTestId = "select_address_and_pay";

    switch (flow) {
        case PAYMENT_FLOWS.WALLET: {
            headerTitle = getStringFromId(
                VERNACULAR_STRING_IDS.WALLET_DYNAMIC_PAY,
                `Adding ₹${formatNumber(grandTotal)} to Nykaa Wallet` || " ",
                { count: grandTotal }
            );
            dataTestId = "lb_adding_money_to_wallet";
            if (paymentScreen === PAYMENT_SCREENS.ALL) {
                headerTitle = allPaymentTitle;
                dataTestId = "lb_pay_all";
            }
            return { headerTitle, dataTestId };
        }
        case PAYMENT_FLOWS.CHECKOUT: {
            if (paymentScreen === PAYMENT_SCREENS.ALL || isNewPaymentMethodVisibleOnScreen1) {
                headerTitle = allPaymentTitle;
                dataTestId = "lb_pay_all";
            }
            return { headerTitle, dataTestId };
        }
        case PAYMENT_FLOWS.GIFT_CARD: {
            headerTitle = getStringFromId(
                VERNACULAR_STRING_IDS.GIFTCARD_DYNAMIC_PAY,
                "Gift Card Payment" || " "
            );
            dataTestId = "lb_giftcardpurchase";
            if (paymentScreen === PAYMENT_SCREENS.ALL) {
                headerTitle = allPaymentTitle;
                dataTestId = "lb_pay_all";
            }
            return { headerTitle, dataTestId };
        }
        case PAYMENT_FLOWS.COD_TO_PREPAID: {
            headerTitle = getStringFromId(VERNACULAR_STRING_IDS.COD_TO_PREPAID_PAY, "Pay now" || " ");
            dataTestId = "lb_pay_now";
            if (paymentScreen === PAYMENT_SCREENS.ALL) {
                headerTitle = allPaymentTitle;
                dataTestId = "lb_Pay_all";
            }
            return { headerTitle, dataTestId };
        }
        default:
            return { headerTitle, dataTestId };
    }
};

export const handleBackButton = (flow: string, paymentScreen: string, shippingAddress: any, isApp: boolean, PaymentBackFriction: any) => {
    if (paymentScreen == PAYMENT_SCREENS.SAVED) {
      setCookie("pinCodeDel", shippingAddress?.postcode, 365);
      setCookie("addressIdDel", shippingAddress?.addressId, 365);

      switch (flow) {
        case PAYMENT_FLOWS.WALLET:
        case PAYMENT_FLOWS.GIFT_CARD:
        case PAYMENT_FLOWS.COD_TO_PREPAID:
          /**
           * redirecting to user to previous page
           */
          handleBack(false);
          break;
        case PAYMENT_FLOWS.CHECKOUT:
          /**
           * in case of checkout flow
           * if backfriction exp is enable we are doing history.back
           * because for backfriction exp we are pushing extra url to
           * stack
           */
          handleBack( !PaymentBackFriction?.experimentEnabled && isApp );
          break;
        default:
          handleBack( !PaymentBackFriction?.experimentEnabled && isApp );
      }
    } else {
      switch (flow) {
        case PAYMENT_FLOWS.WALLET:
        case PAYMENT_FLOWS.GIFT_CARD:
        case PAYMENT_FLOWS.COD_TO_PREPAID:
           /**
           * redirecting to user to previous page
           */
            handleBack(false);
          break;
        case PAYMENT_FLOWS.CHECKOUT:
          handleBack(false);
          trackBackButtonClickToSavedPaymentPage();
          break;
        default:
          handleBack(false);
          trackBackButtonClickToSavedPaymentPage();
      }
    }
};

/**
 * incase of webview redirecting to native cart o/w
 * call windows default back functionality.
 */
export const handleBack = (openNativePreviousPage: boolean) => {
    if (openNativePreviousPage) {
      doCallAppCallback({
        name: AppCallback.DO_REDIRECT_TO_CART,
        data: {},
      });
    } else {
      window.history.back();
    }
};

/**
 * function to check if upiIntent is visible on web.
 * this is only for gpay.
 */
export const checkUpiIntentVisibilityOnWeb = ({
  availablePaymentMethods,
  cashFreePaymentGateway,
  isApp,
  setIsGpayIntentLoading,
  gPayExperiment,
}: IUpiIntentVisibleOnWeb) => {
  if (
    !availablePaymentMethods ||
    !availablePaymentMethods.includes(toLowerCase(PAYMENT_MODES.UPI_INTENT)) ||
    cashFreePaymentGateway ||
    !gPayExperiment ||
    isApp
  ) {
   setIsGpayIntentLoading && setIsGpayIntentLoading(false);
    return false;
  }

  return true;
};

/**
 * function to show gpay, phonePay, paytm as upi intent flow.
 * this is only for Mweb.
 */
export const checkAllUpiIntentVisibilityOnWeb = ({
  availablePaymentMethods,
  isExperimentEnable,
  cashFreePaymentGateway,
}: IUpiIntentVisibleOnWeb) => {
  try {
    const remoteConfig = getRemoteConfig();

    const availableBrowserList =
      remoteConfig.configs.payment.availableBrowserListForUpiIntent || [];
    const availableOsList = remoteConfig.configs.payment.availableOsListForUpiIntent || [];

    const currentMobileOs = getMobileOperatingSystem();
    const currentBrowser = getBrowserName();

    /**
     * Browser specific switch to disable UPI intent on particular browser.
     */
    if (!availableOsList.includes(currentMobileOs)) return false;

    /**
     * Device OS level switch to disable  UPI intent on particular OS.
     */
    if (!availableBrowserList.includes(currentBrowser)) return false;

    /**
     * we are not showing upi intent for marketplace & ngs
     * for marketplace and ngs we are receiving payment gateway
     * as cashFreePaymentGateway.
     */
    if (
      !cashFreePaymentGateway &&
      availablePaymentMethods &&
      availablePaymentMethods.includes(toLowerCase(PAYMENT_MODES.UPI_INTENT)) &&
      isExperimentEnable
    ) {
      return true;
    }

    return false;
  } catch (error) {
    logger.error(
      error,
      "unable to fetch availableBrowserListForUpiIntent or availableOsListForUpiIntent "
    );
  }

  return false;
};

export const loadUpiIntentForWeb = ({
  razorPayKey,
  cashFreePaymentGateway,
  setIsGPayIntentAvailable,
  setIsGpayIntentLoading,
  gPayExperiment,
  setIsUpiIntentAppsInfoLoading,
}: ILoadUpiIntentForWeb) => {
  // load razorpay if experiment is true and non market place
  if (razorPayKey && gPayExperiment && !cashFreePaymentGateway) {
    if (setIsUpiIntentAppsInfoLoading) {
        setIsUpiIntentAppsInfoLoading(true);
    }
    razorPayIntegrationInstance
      .getInstance({ key: razorPayKey })
      .then((razorPayInstance: any) => {
        razorPayInstance
          .checkPaymentAdapter("gpay")
          .then(() => {
            // Google Pay is available, show the googlePay intent design
            setIsGPayIntentAvailable(true);
            if (setIsUpiIntentAppsInfoLoading) {
              setIsUpiIntentAppsInfoLoading(false);
            }
            setIsGpayIntentLoading(false);
          })
          .catch((error: Error) => {
            if (setIsUpiIntentAppsInfoLoading) {
              setIsUpiIntentAppsInfoLoading(false);
            }
            // logging to sentry as warning
            logger.error(error);
            setIsGpayIntentLoading(false);
          });
      })
      .catch(error => {
        if (setIsUpiIntentAppsInfoLoading) {
          setIsUpiIntentAppsInfoLoading(false);
        }
        // logging to sentry as warning
        logger.error(error, "Razorpay instance not available");
        setIsGpayIntentLoading(false);
      });
  } else {
    if (!razorPayKey) return;
    setIsGpayIntentLoading(false);
  }
};

/**
 * function to fetch upiIntent list from remoteConfig.
 */
export const getUpiIntentListFromRemoteConfig = () => {
  const remoteConfig = getRemoteConfig();
  const defaultUpiIntentList = [
    {
      title: "Google Pay",
      icon: "https://images-static.nykaa.com/media/desktop-icons/googlePay.svg",
      merchantKey: "gpay",
    },
    {
      title: "PhonePe",
      icon: "https://images-static.nykaa.com/media/desktop-icons/phonePe.svg",
      merchantKey: "phonepe",
    },
    {
      title: "Paytm",
      icon: "https://images-static.nykaa.com/media/desktop-icons/paytm.svg",
      merchantKey: "paytm",
    },
  ];

  try {
    const upiIntentList = remoteConfig.configs.payment.availableUpiIntentMethodList;
    return upiIntentList || defaultUpiIntentList;
  } catch (error) {
    logger.error(error, "Unable to fetch upiIntetn list from remote config");
    return defaultUpiIntentList;
  }
};

/**
 * function to get available payment method on saved payment screen
 */
export const getAvailablePaymentMethodOnSavedPaymentScreen = ({
  availablePaymentMethods,
  isCodAvailable,
}: {
  availablePaymentMethods: string[];
  isCodAvailable: boolean;
}) => {
  try {
    /**
     * filtering out paymentMethod for saved payment screen from availablePaymentMethods.
     */
    const remoteConfig = getRemoteConfig();
    const remoteConfigMethod =
      remoteConfig.configs.payment.availablePaymentMethodOnSavedPaymentPage || [];
    return remoteConfigMethod.filter((method: string) => {
      if (method === ACCORDIAN.COD) {
         return isCodAvailable && availablePaymentMethods.includes(method);
      }
      return availablePaymentMethods.includes(method);
    });
  } catch (error) {
    logger.error(new Error("Unable to fetch new paymentMethod for saved payment page"));
  }

  return [];
};

/**
 * function to check if new payment pethod is visible or not.
 */
export const checkIsNewPaymentMethodVisibleOnScreen1 = ({
  isExperimentEnable,
  grandTotal,
  flow,
  availablePaymentMethods,
  isCodAvailable,
  cartErrorMessage,
}: {
  isExperimentEnable: boolean;
  grandTotal: number;
  flow: string;
  availablePaymentMethods: string[];
  isCodAvailable: boolean;
  cartErrorMessage: string;
}) => {
  /**
   * when ther is cart Error Message then does'nt show new Payment method on
   * first screen.
   */
  if (cartErrorMessage) return false;

  const validPaymentMethods = getAvailablePaymentMethodOnSavedPaymentScreen({
    availablePaymentMethods,
    isCodAvailable,
  });
  return Boolean(
    isExperimentEnable &&
      grandTotal > 0 &&
      flow === PAYMENT_FLOWS.CHECKOUT &&
      validPaymentMethods.length
  );
};

/**
 * function to two cod attributes
 *  1. isCodAvailable - Whether the user can pay using cod as payment mode
 *  2. isCodShown - Whether the cod option is shown to the user, it can be in a disabled state as well
 * JIRA: https://nykmage.atlassian.net/browse/FC-4788
 */
export const getCodAvailableAttributes = ({
  availablePaymentMethods,
  isCodAvailable,
}: {
  availablePaymentMethods: string[];
  isCodAvailable: boolean;
}) => {
  let isCodShown = false;
  let isCodAvailableForUser = false;
  try {
    /**
     * check if cod is available in availablePaymentMethods
     * cod will be shown to user only if it is available in availablePaymentMethods
     */
    if (availablePaymentMethods.includes(ACCORDIAN.COD)) {
      isCodShown = true;
    }

    /**
     * check if cod is available and is shown to user
     * it will be based on availablePaymentMethodDTO.codAvailable from cart
     */
    isCodAvailableForUser = isCodAvailable && isCodShown;
  } catch (error) {
    logger.error(new Error("Unable to fetch isCodAvailable & isCodShown attributes"));
    return { isCodAvailable: false, isCodShown: false };
  }

  return { isCodAvailable: isCodAvailableForUser, isCodShown };
};

/**
 * fuction check single payment page eligibility
 */

export const checkSinglePaymentPageEligibility = ({ flow }: { flow: string }) => {
  try {
    const remoteConfig = getRemoteConfig();
    const availableFlowForSinglePaymentPage =
      remoteConfig?.configs?.payment?.availableFlowForSinglePaymentPage || [];

    if (availableFlowForSinglePaymentPage.includes(flow)) {
      return true;
    }

    return false;
  } catch (error) {
    logger.error(error, "error in checkSinglePaymentPageEligibility function");
    return false;
  }
};

/**
 * function to Toast timer from remote config.
 */
 export const getToastTimer = () => {
  let timer = 3000;
  try {
    const remoteConfig = getRemoteConfig();
    const timerFromRemoteConfig = remoteConfig?.configs?.payment?.timer?.toastTimer;
    if (timerFromRemoteConfig) {
      timer = timerFromRemoteConfig;
    }
  } catch (error) {
    logger.error(new Error("Failed to load Toast timer"));
  }

  return timer;
};

export const getQueryStrings = (searchString: string) => new URLSearchParams(searchString);

export const isGrahakServiceEnabled = () => {
  try {
    const remoteConfig = getRemoteConfig();
    return remoteConfig?.switches?.isGrahakServiceEnabled?.status;
  } catch (error) {
    return false;
  }
};
